import createAction from 'redux-actions/lib/createAction';
import {PUB_SUB_CHANNEL_APP} from '../../../constants';

export const IS_MODAL_LOADED = 'modal/IS_LOADED';

export const setIsLoaded = createAction(IS_MODAL_LOADED, payload => payload, () => ({
  publish: [PUB_SUB_CHANNEL_APP],
  pass: true,
}));
